const DoubleClickDirective = {
    bind(el, binding) {
        const singleClickHandler = binding.value.single || null; // Single click handler
        const doubleClickHandler = binding.value.double || null; // Double click handler
        const delay = binding.arg || 200;

        let clickTimeout = null;

        el.addEventListener("click", (event) => {
            if (clickTimeout) {
                // If clickTimeout exists, it's a double click
                clearTimeout(clickTimeout);
                clickTimeout = null;

                if (typeof doubleClickHandler === "function") {
                    doubleClickHandler(event); // Execute Double Click Handler
                }
            } else {
                // Single click detected; start a timeout to check for a double click
                clickTimeout = setTimeout(() => {
                    clickTimeout = null;

                    if (typeof singleClickHandler === "function") {
                        singleClickHandler(event); // Execute Single Click Handler
                    }
                }, delay);
            }
        });
    },
    unbind(el) {
        el.removeEventListener("click", () => { });
    },
};

export default DoubleClickDirective;
